import './App.css';
import { Login } from "./components/login";
import { Route, Routes } from 'react-router-dom';
import { About } from './pages/about';
import { Home } from './pages/home';
import { MyProjects } from './pages/myprojects';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { User } from './pages/user';
import { AuthProvider } from './contexts/authContext';
import PrivateRoute from './components/privateRoute';
import { PublicProjects } from './pages/publicProjects';
import { ProjectPrivate } from './pages/projectPrivate';
import { ProjectPublic } from './pages/projectPublic';
import { Tos } from './pages/tos';
import { CommingSoon } from './pages/comingsoon';

function App() {

  const client = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
      },
    },
  });

  function NoMatch() {
    return (
      <div>
        <h3>
          404
        </h3>
      </div>
    );
  }

  return (
    <div className="App">
      <AuthProvider>
        <QueryClientProvider client={client}>
          <Routes>
            {/* <Route path='/' element={<Home />} /> */}
            <Route path='/' element={<CommingSoon />} />
            <Route path="/about" element={<About />} />
            <Route path="/project/:id" element={<PrivateRoute><ProjectPrivate /></PrivateRoute>} />
            <Route path="/p/:id" element={<ProjectPublic />} />
            <Route path="/myprojects" element={<PrivateRoute><MyProjects /></PrivateRoute>} />
            <Route path="/publicprojects" element={<PublicProjects />} />
            <Route path='/user' element={<PrivateRoute><User /></PrivateRoute>} />
            <Route path='/login' element={<Login />} />
            <Route path='/tos' element={<Tos />} />
            <Route path='*' element={<NoMatch />} />
          </Routes>
        </QueryClientProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
